import { getData } from './index';
import {
  ERROR_CONTENT,
  GET_TOOL,
  GET_THERAPEUTIC_AREAS,
  GET_THERAPEUTIC_AREA,
  GET_DRUGS,
  GET_DRUG,
  GET_DRUG_VARIATIONS,
  GET_PATHOLOGIES,
  GET_PATHOLOGY,
  GET_CENTERS,
  GET_CENTER,
  GET_CONTACTS,
  GET_CONTACT,
  GET_CONGRESS_ITEM,
  GET_COMPANIES,
  GET_COMPANY,
} from './types';

export async function getToolAction(dispatch, id) {
  const url = `/tool/${id}`;
  let tool;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    tool = response.tool;
  });
  dispatch({ type: GET_TOOL, payload: tool });
}

export async function getTherapeuticAreasAction(dispatch) {
  const url = '/therapeuticarea';
  let list;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    list = response.therapeuticAreas;
  });
  dispatch({ type: GET_THERAPEUTIC_AREAS, payload: list });
}

export async function getTherapeuticAreaAction(dispatch, id) {
  const url = `/therapeuticarea/${id}`;
  let item;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    item = response.therapeuticArea;
  });
  dispatch({ type: GET_THERAPEUTIC_AREA, payload: item });
}

export async function getDrugsAction(dispatch) {
  const url = '/drug';
  let drugs;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    drugs = response.drugs;
  });
  dispatch({ type: GET_DRUGS, payload: drugs });
}

export async function getDrugAction(dispatch, id) {
  const url = `/drug/${id}?withVariations=true`;
  let drug;
  let variations = [];
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    drug = response.drug;
    variations = response.variations || [];
  });
  dispatch({ type: GET_DRUG, payload: drug });
  dispatch({ type: GET_DRUG_VARIATIONS, payload: variations });
}

export async function getPathologiesAction(dispatch) {
  const url = '/pathology';
  let pathologies;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    pathologies = response.pathologies;
  });
  dispatch({ type: GET_PATHOLOGIES, payload: pathologies });
}

export async function getPathologyAction(dispatch, id) {
  const url = `/pathology/${id}`;
  let pathology;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    pathology = response.pathology;
  });
  dispatch({ type: GET_PATHOLOGY, payload: pathology });
}

export async function getCentersAction(dispatch) {
  const url = '/center';
  let centers;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    centers = response.centers;
  });
  dispatch({ type: GET_CENTERS, payload: centers });
}

export async function getCenterAction(dispatch, id) {
  const url = `/center/${id}`;
  let center;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    center = response.center;
  });
  dispatch({ type: GET_CENTER, payload: center });
}

export async function getContactsAction(dispatch) {
  const url = '/contact';
  let contacts;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    contacts = response.contacts;
  });
  dispatch({ type: GET_CONTACTS, payload: contacts });
}

export async function getContactAction(dispatch, id) {
  const url = `/contact/${id}`;
  let contact;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    contact = response.contact;
  });
  dispatch({ type: GET_CONTACT, payload: contact });
}

export async function getCongressItemAction(dispatch, id) {
  const url = `/congress/${id}`;
  let congress;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    congress = response.congress;
  });
  dispatch({ type: GET_CONGRESS_ITEM, payload: congress });
}

export async function getCompaniesAction(dispatch) {
  const url = '/company';
  let companies;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    companies = response.companies;
  });
  dispatch({ type: GET_COMPANIES, payload: companies });
}

export async function getCompanyAction(dispatch, id) {
  const url = `/company/${id}`;
  let company;
  await getData(ERROR_CONTENT, url, dispatch, true).then((response) => {
    company = response.company;
  });
  dispatch({ type: GET_COMPANY, payload: company });
}
